import { FunctionComponent } from 'react';
import { FlexContainer } from '@astrumu/ui-library';

import { HeaderSkeleton } from '@/components/Header/Skeleton';
import { OverviewSkeleton } from '@/components/Overview/Skeleton';
import { IntroductionSkeleton } from '@/components/Introduction/Skeleton';

export const IndexPageSkeleton: FunctionComponent = () => (
  <FlexContainer style={{ flexDirection: 'column', gap: 80 }}>
    <HeaderSkeleton />
    <IntroductionSkeleton />
    <OverviewSkeleton />
  </FlexContainer>
);
